import { forwardRef, useState } from 'react';
import Wizard from '../shared/components/wizard';
import ChartTypeWizardSection from './sections/ChartType';
import DisplaySettingsWizardSection from './sections/DisplaySettings';
import ValuesAndConstraintsWizardSection from './sections/ValuesAndConstraints';
import { AREA_RESPONSES } from './types';

const isStep2Current = ({ field, reportType, salesReportType }) => {
  if (
    reportType?.value === AREA_RESPONSES.TABLE ||
    reportType?.value === AREA_RESPONSES.PIVOT_TABLE
  ) {
    return true;
  }

  if (reportType?.value === AREA_RESPONSES.SALES) {
    return Boolean(salesReportType);
  }

  return Boolean(reportType) && Boolean(field);
};

const isStep3Current = ({
  reportType,
  value,
  datapointFrequency,
  customEndDate,
  endDate,
}) => {
  if (reportType?.value === AREA_RESPONSES.SALES) {
    return (
      Boolean(value) &&
      Boolean(datapointFrequency) &&
      (customEndDate ? Boolean(endDate) : true)
    );
  }
  return Boolean(reportType);
};

const RTDVWizard = forwardRef(
  (
    {
      objectId,
      contacts,
      clientObjectId,
      currentDashboard,
      autoOpenAIOverlay = false,
      isEditing = false,
      canAutoScroll = true,
      ...props
    },
    ref
  ) => {
    const { homepage } = props;
    const [selectedObjectId, setSelectedObjectId] = useState(objectId);
    const [isContacts, setIsContacts] = useState(contacts);

    const enableAutoScroll = canAutoScroll && !isEditing;

    return (
      <Wizard
        ref={ref}
        controllers={[isStep2Current, isStep3Current]}
        charts
        isEditing={isEditing}
        canAutoScroll={enableAutoScroll}
        {...props}
      >
        <ChartTypeWizardSection
          objectId={selectedObjectId}
          originalObjectId={objectId}
          contacts={isContacts}
          setSelectedObjectId={setSelectedObjectId}
          setIsContacts={setIsContacts}
          clientObjectId={clientObjectId}
          homepageSelectedObjectId={selectedObjectId}
          currentDashboard={currentDashboard}
          homepage={homepage}
          autoOpenAIOverlay={autoOpenAIOverlay}
          isEditing={isEditing}
        />
        <ValuesAndConstraintsWizardSection
          objectId={selectedObjectId}
          contacts={isContacts}
        />
        <DisplaySettingsWizardSection
          objectId={selectedObjectId}
          contacts={isContacts}
          dashboardConfigSettings={currentDashboard?.styleSettings}
        />
      </Wizard>
    );
  }
);

export default RTDVWizard;
